export default "__VITE_PUBLIC_ASSET__53467dca__"